/* script */
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import { humanizeTimeLeft, nowUnixTimestamp } from 'libs/utils/time';

const __vue_script__ = {
    name: 'VideoProcessingStatus',

    props: {
        video: {
            type: Object,
            required: true
        },

        defaultText: {
            type: String,
            required: false,
            default: ''
        },

        forceNormalization: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            now: nowUnixTimestamp(),
            clockInterval: null
        };
    },

    computed: {
        isProcessing() {
            if (this.hasError) {
                return false;
            }

            if (!this.video.normalization_enforced && !this.forceNormalization) {
                // Backwards comp.
                return !this.video.url;
            }

            return !this.video.video_processing_successful;
        },

        hasError() {
            // On input-switch we use `error`
            return Boolean(this.video.error || this.video.upload_error);
        },

        processingTimeLeft() {
            if (!this.video.normalization_enforced || !this.isProcessing) {
                return;
            }

            if (!this.video.estimated_transcoding_finished_timestamp) {
                return this.$i18n.t('media.list.estimating_processing') + '.'.repeat((this.now % 3) + 1);
            }

            const secsLeft = this.video.estimated_transcoding_finished_timestamp - this.now;

            if (secsLeft < -(30 * 60)) {
                return this.$i18n.t('media.list.processing_taking_too_long');
            }

            return (secsLeft > 60) ? `${humanizeTimeLeft(secsLeft)} ${this.$i18n.t('media.list.remaining')}` : this.$i18n.t('media.list.processing_over_soon');
        },

        isStatusAnimated() {
            if (!this.video.normalization_enforced || !this.isProcessing) {
                return false;
            }

            return !this.video.estimated_transcoding_finished_timestamp;
        }
    },

    created() {
        this.clockInterval = setInterval(() => {
            this.now = nowUnixTimestamp();
        }, 1000);
    },

    beforeDestroy() {
        clearInterval(this.clockInterval);
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-processing-status" }, [
    _vm.hasError
      ? _c("div", { staticClass: "error" }, [
          _c("p", { staticClass: "badge" }, [
            _vm._v(_vm._s(_vm.$t("media.list.failed"))),
          ]),
        ])
      : _vm.isProcessing
      ? _c("div", { staticClass: "processing" }, [
          _c("p", { staticClass: "badge" }, [
            _vm._v(_vm._s(_vm.$t("media.list.processing"))),
          ]),
          _vm.processingTimeLeft
            ? _c(
                "p",
                {
                  staticClass: "status",
                  class: { "animated-status": _vm.isStatusAnimated },
                },
                [_vm._v(_vm._s(_vm.processingTimeLeft))]
              )
            : _vm._e(),
        ])
      : _c("div", { staticClass: "default" }, [
          _c("p", [_vm._v(_vm._s(_vm.defaultText))]),
        ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/media/VideoProcessingStatus.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__